import { buildViewAriaLabel, buildViewText } from './drilldownLinkHelper.labels';

export interface DrilldownState extends Record<string, unknown> {
	referrer: string;
}

interface DrilldownLink {
	text: string;
	url: string;
	ariaLabel: string;
	state: DrilldownState;
}

type BuildDrilldownUrl = (isUnique: boolean, severity?: string) => string;

export const isValidReferrer = (referrer: unknown): referrer is string => {
	return typeof referrer === 'string' && referrer.startsWith('/') && !referrer.startsWith('//');
};

export const buildDrilldownLink = (
	label: string,
	isUnique: boolean,
	buildUrl: BuildDrilldownUrl,
	referrerPath: string,
	severity?: string
): DrilldownLink => ({
	text: buildViewText(label),
	url: buildUrl(isUnique, severity),
	ariaLabel: buildViewAriaLabel(label),
	state: { referrer: referrerPath }
});
